import {Tooltip} from "@blueprintjs/core";
import {FormEvent} from "react";
import {InformationIcon} from "../../../../common/icons";
import {ContentBottom, ContentContainer, ContentTitle, ContentTop} from "../styles";

export interface ContentOption {
  group?: string;
  label: string;
  value: string | number;
}

export interface ContentProps {
  contentTitle: string;
  contentOptions: ContentOption[];
  contentInformation: string | JSX.Element;
  contentUnit: string;
  selectedOption: string | number;
  handleChangeOption: (event: FormEvent<HTMLInputElement>) => void;
  renderPropComponents: (contentProps: ContentProps) => JSX.Element;
  isDisabled: () => boolean;
  handleBlur?: (event: FormEvent<HTMLInputElement>) => void;
  tooltipContent?: () => string | JSX.Element;
}

const Content: React.FC<ContentProps> = (contentProps: ContentProps) => {
  const {contentTitle, contentInformation, renderPropComponents} = contentProps;
  return (
    <ContentContainer>
      <ContentTop>
        <ContentTitle>{contentTitle}</ContentTitle>
        <Tooltip content={contentInformation} placement="bottom-end" popoverClassName="content-tooltip">
          <div data-testid="information-icon">
            <InformationIcon />
          </div>
        </Tooltip>
      </ContentTop>
      <ContentBottom>{renderPropComponents(contentProps)}</ContentBottom>
    </ContentContainer>
  );
};

export default Content;
